__turbopack_context__.v({
  "container": "TrustPilotTwoLinesWidget-module__h4F5QG__container",
  "stats": "TrustPilotTwoLinesWidget-module__h4F5QG__stats",
});
